var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    viewBox: "0 0 46 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3055 3.2939V0.189453H19.8678V3.2939C8.9559 4.02523 0.554688 8.35354 0.554688 13.6221V16.6072H45.6187V13.6221C45.6187 8.35354 37.2174 4.02523 26.3055 3.2939Z",
    fill: "#0A2240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 27.0534C24.8638 27.0534 26.3049 26.3852 26.3049 25.5609C26.3049 24.7366 24.8638 24.0684 23.086 24.0684C21.3083 24.0684 19.8672 24.7366 19.8672 25.5609C19.8672 26.3852 21.3083 27.0534 23.086 27.0534Z",
    fill: "#0A2240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathRoom);
export default __webpack_public_path__ + "static/media/bath-room.473e4e202c219d0c1a1463bc4b1efa37.svg";
export { ForwardRef as ReactComponent };